import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

export const AvatarTailwindThemes = {
  avatar: {
    root: ({ props, state }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'flex items-center justify-center',
        'bg-gray-300',
        {
          'rounded-lg': props.shape == 'square',
          'rounded-full': props.shape == 'circle',
        },
        {
          'text-base h-8 w-8': props.size == null || props.size == 'normal',
          'w-12 h-12 text-xl': props.size == 'large',
          'w-16 h-16 text-2xl': props.size == 'xlarge',
        },
        {
          '-ml-4 border-2 border-white': state.isNestedInAvatarGroup,
        },
      ),
    }),
    image: ({ props }: PrimeReactStylesFunctionType) => ({
      className: classNames('h-full w-full', {
        'rounded-full': props.shape == 'circle',
      }),
    }),
  },
  avatargroup: {
    root: 'flex items-center',
  },
};
